/**
 * Google Analytics voor het dashboard zelf — pas laden ná toestemming.
 *
 * Niet te verwarren met lib/googleAnalytics.js: dat koppelt het GA-account
 * van een klant om hun statistieken op te halen. Dit bestand gaat over de
 * meting van dit platform zelf.
 *
 * De gtag-stub en de consent-default ("denied") staan in public/index.html;
 * het eigenlijke script gtag.js halen we hier binnen, en enkel wanneer de
 * gebruiker in de cookiebanner op "Accepteren" klikt.
 *
 * Waarom niet gewoon Consent Mode zijn werk laten doen? Met de tag altijd
 * geladen stuurt Google ook bij "geweigerd" nog cookieloze pings — geen
 * cookies, maar wél je IP-adres naar een server van Google. Door het script
 * pas te laden na een "ja" vertrekt er zonder toestemming letterlijk niets.
 */

export const GA_MEASUREMENT_ID = "G-G6PZ3CVEL5";

let bezig = false;

/** Haalt gtag.js binnen en start de meting. Meermaals aanroepen is veilig. */
export function laadAnalytics() {
  if (bezig || typeof window === "undefined" || typeof document === "undefined") {
    return;
  }
  bezig = true;

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  script.dataset.googleAnalytics = "";
  document.head.appendChild(script);

  // gtag() is de stub uit index.html: die schrijft in dataLayer, en gtag.js
  // werkt die rij af zodra het geladen is.
  window.gtag("js", new Date());
  window.gtag("config", GA_MEASUREMENT_ID);
}

/**
 * Eén paginaweergave melden bij een routewissel.
 *
 * Het dashboard is een single-page app: navigeren naar "Bestellingen" herlaadt
 * de pagina niet, dus Google ziet die overgang niet vanzelf.
 *
 * We sturen bewust enkel het pad mee zoals React Router het kent. Sommige
 * dashboardroutes bevatten een id (bijvoorbeeld /dashboard/offertes/details/42);
 * dat is een verwijzing naar een record van de klant, geen persoonsgegeven op
 * zich, maar we geven het ook niet aan Google mee als queryparameter.
 *
 * LET OP bij het instellen van de property: laat in Google Analytics onder
 * "Uitgebreide meting" de optie *paginawijzigingen op basis van
 * browsergeschiedenis* uit staan. Zet je die aan, dan telt elke navigatie
 * dubbel — één keer door Google, één keer door deze functie.
 */
export function meldPaginaweergave(pad) {
  // Geen toestemming → geen script → niets te melden.
  if (!bezig || typeof window.gtag !== "function") return;
  window.gtag("event", "page_view", {
    page_path: pad,
    page_location: `${window.location.origin}${pad}`,
  });
}
